import apiConfig from "../ApiConfig";
// import Ai_DSPM from ""
/**
 * Fetches live company overview data for the CustomerAdmin dashboard.
 * Returns company info, risk stats, incident stats, framework count,
 * team size, security score, and compliance rate — all scoped to the
 * logged-in user's company.
 */
// ================= Dashboard =================
export const fetchDashboardTrend = async () => {
  try {
    const response = await apiConfig.get("/api/ai_dspm/dashboard/trend/");
    return response.data;
  } catch (error) {
    console.log("Dashboard Trend Error:", error);
    throw error;
  }
};

export const fetchDashboardProviders = async () => {
  try {
    const response = await apiConfig.get("/api/ai_dspm/dashboard/providers/");
    return response.data;
  } catch (error) {
    console.log("Dashboard Providers Error:", error);
    throw error;
  }
};

export const fetchDashboardStats = async () => {
  try {
    const response = await apiConfig.get("/api/ai_dspm/dashboard/stats/");

    return response.data;
  } catch (error) {
    console.log("Dashboard Stats Error:", error);
    throw error;
  }
};

// ================= Data Stores (Assets) =================

// Get all assets
// export const fetchDataStores = async () => {
//   try {
//     const response = await apiConfig.get("/api/ai_dspm/data-stores/");

//     return response.data;
//   } catch (error) {
//     console.log("Fetch Data Stores Error:", error);
//     throw error;
//   }
// };

// // Get asset summary
// export const fetchDataStoreSummary = async () => {
//   try {
//     const response = await apiConfig.get("/api/ai_dspm/data-stores/summary/");

//     return response.data;
//   } catch (error) {
//     console.log("Fetch Data Store Summary Error:", error);
//     throw error;
//   }
// };

// // Get asset by id
// export const fetchDataStoreById = async (id) => {
//   try {
//     const response = await apiConfig.get(`/api/ai_dspm/data-stores/${id}/`);

//     return response.data;
//   } catch (error) {
//     console.log("Fetch Data Store By Id Error:", error);
//     throw error;
//   }
// };

// // Create asset
// export const createDataStore = async (data) => {
//   try {
//     const response = await apiConfig.post(
//       "/api/ai_dspm/data-stores/create/",
//       data,
//     );

//     return response.data;
//   } catch (error) {
//     console.log("Create Data Store Error:", error);
//     throw error;
//   }
// };

// // Update asset
// export const updateDataStore = async (id, data) => {
//   try {
//     const response = await apiConfig.put(
//       `/api/ai_dspm/data-stores/${id}/update/`,
//       data,
//     );

//     return response.data;
//   } catch (error) {
//     console.log("Update Data Store Error:", error);
//     throw error;
//   }
// };

// // Delete asset
// export const deleteDataStore = async (id) => {
//   try {
//     const response = await apiConfig.delete(
//       `/api/ai_dspm/data-stores/${id}/delete/`,
//     );

//     return response.data;
//   } catch (error) {
//     console.log("Delete Data Store Error:", error);
//     throw error;
//   }
// };
export const fetchAssets = async (customerId = "", sensitiveData = true) => {
  const response = await apiConfig.get("/api/ai_dspm/assets/", {
    params: {
      customer_id: customerId,
      sensitiveData,
    },
  });

  return response.data;
};
// ================= Rules =================

export const fetchRules = async (params = {}) => {
  try {
    const response = await apiConfig.get("/api/ai_dspm/checks/", {
      params,
    });

    return response.data;
  } catch (error) {
    console.log("Rules Error:", error);
    throw error;
  }
};

// Customer Admin's Rules table: Platform rules + their own
// CustomerDataCheck records, merged and paginated server-side.
export const fetchCombinedRules = async (params = {}) => {
  try {
    const response = await apiConfig.get("/api/ai_dspm/checks/combined/", {
      params,
    });

    return response.data;
  } catch (error) {
    console.log("Combined Rules Error:", error);
    throw error;
  }
};

export const fetchRuleById = async (id) => {
  try {
    const response = await apiConfig.get(`/api/ai_dspm/checks/${id}/`);

    return response.data;
  } catch (error) {
    console.log("Rule Detail Error:", error);
    throw error;
  }
};

export const createRule = async (data) => {
  try {
    const response = await apiConfig.post("/api/ai_dspm/checks/create/", data);

    return response.data;
  } catch (error) {
    console.log("Create Rule Error:", error);
    throw error;
  }
};

export const updateRule = async (id, data) => {
  try {
    const response = await apiConfig.put(
      `/api/ai_dspm/checks/${id}/update/`,
      data,
    );

    return response.data;
  } catch (error) {
    console.log("Update Rule Error:", error);
    throw error;
  }
};

export const deleteRule = async (id) => {
  try {
    const response = await apiConfig.delete(
      `/api/ai_dspm/checks/${id}/delete/`,
    );

    return response.data;
  } catch (error) {
    console.log("Delete Rule Error:", error);
    throw error;
  }
};

// Master Risk Management catalog for the Risk Mapping checklist -
// DSPM-owned endpoint (not the CSPM one).
export const fetchAllRisks = async () => {
  try {
    const response = await apiConfig.get("/api/ai_dspm/risk-catalog/");

    return response.data;
  } catch (error) {
    console.log("Risk List Error:", error);
    throw error;
  }
};

// ================= Customer Data Check (Customer Admin's own rules) =================
// Fully separate collection/APIs from the Platform Rules (checks/)
// module above - never reads/writes DSPMCheck.

export const fetchCustomerDataChecks = async () => {
  try {
    const response = await apiConfig.get("/api/ai_dspm/customer-data-check/");

    return response.data;
  } catch (error) {
    console.log("Customer Data Check List Error:", error);
    throw error;
  }
};

export const fetchCustomerDataCheckById = async (id) => {
  try {
    const response = await apiConfig.get(`/api/ai_dspm/customer-data-check/${id}/`);

    return response.data;
  } catch (error) {
    console.log("Customer Data Check Detail Error:", error);
    throw error;
  }
};

export const createCustomerDataCheck = async (data) => {
  try {
    const response = await apiConfig.post(
      "/api/ai_dspm/customer-data-check/",
      data,
    );

    return response.data;
  } catch (error) {
    console.log("Create Customer Data Check Error:", error);
    throw error;
  }
};

export const updateCustomerDataCheck = async (id, data) => {
  try {
    const response = await apiConfig.put(
      `/api/ai_dspm/customer-data-check/${id}/`,
      data,
    );

    return response.data;
  } catch (error) {
    console.log("Update Customer Data Check Error:", error);
    throw error;
  }
};

// ================= Findings =================

export const fetchFindings = async (params = {}) => {
  try {
    const response = await apiConfig.get("/api/ai_dspm/findings/", {
      params,
    });

    return response.data;
  } catch (error) {
    console.log("Findings Error:", error);
    throw error;
  }
};

export const createFinding = async (data) => {
  try {
    const response = await apiConfig.post("/api/ai_dspm/findings/", data);

    return response.data;
  } catch (error) {
    console.log("Create Finding Error:", error);
    throw error;
  }
};

export const fetchFindingById = async (findingId) => {
  try {
    const response = await apiConfig.get(
      `/api/ai_dspm/findings/${findingId}/`,
    );

    return response.data;
  } catch (error) {
    console.log("Finding Detail Error:", error);
    throw error;
  }
};

export const deleteFinding = async (findingId) => {
  try {
    const response = await apiConfig.delete(
      `/api/ai_dspm/findings/${findingId}/`,
    );

    return response.data;
  } catch (error) {
    console.log("Delete Finding Error:", error);
    throw error;
  }
};

// ================= Sensitive Data =================

export const fetchSensitiveData = async (customerId) => {
  try {
    const response = await apiConfig.get("/api/ai_dspm/sensitive-data/", {
      params: {
        customer_id: customerId,
      },
    });

    return response.data;
  } catch (error) {
    console.log("Sensitive Data Error:", error);
    throw error;
  }
};

export const fetchSensitiveDataById = async (id) => {
  try {
    const response = await apiConfig.get(`/api/ai_dspm/sensitive-data/${id}/`);

    return response.data;
  } catch (error) {
    console.log("Sensitive Detail Error:", error);
    throw error;
  }
};

// ================= Risks =================

export const fetchRisks = async () => {
  try {
    const response = await apiConfig.get("/api/ai_dspm/risks/");

    return response.data;
  } catch (error) {
    console.log("Risk Error:", error);
    throw error;
  }
};

export const fetchRiskById = async (id) => {
  try {
    const response = await apiConfig.get(`/api/ai_dspm/risks/${id}/`);

    return response.data;
  } catch (error) {
    console.log("Risk Detail Error:", error);
    throw error;
  }
};

// ================= Compliance =================

export const fetchCompliance = async () => {
  try {
    const response = await apiConfig.get("/api/ai_dspm/compliance/");

    return response.data;
  } catch (error) {
    console.log("Compliance Error:", error);
    throw error;
  }
};

export const fetchComplianceById = async (id) => {
  try {
    const response = await apiConfig.get(`/api/ai_dspm/compliance/${id}/`);

    return response.data;
  } catch (error) {
    console.log("Compliance Detail Error:", error);
    throw error;
  }
};

// ================= Compliance Master (PlatformAdmin, asset-driven) =================

export const fetchDspmComplianceMasterFrameworks = async () => {
  try {
    const response = await apiConfig.get("/api/ai_dspm/compliance-master/frameworks/");
    return response.data;
  } catch (error) {
    console.log("Compliance Master Frameworks Error:", error);
    throw error;
  }
};

export const fetchDspmComplianceMasterFrameworkControls = async (frameworkId, search = "") => {
  try {
    const response = await apiConfig.get(
      `/api/ai_dspm/compliance-master/frameworks/${frameworkId}/controls/`,
      { params: { search } }
    );
    return response.data;
  } catch (error) {
    console.log("Compliance Master Controls Error:", error);
    throw error;
  }
};

// ================= Compliance Master (CustomerAdmin, customer-scoped) =================

export const fetchCustomerComplianceFrameworks = async () => {
  try {
    const response = await apiConfig.get("/api/ai_dspm/customer-compliance/frameworks/");
    return response.data;
  } catch (error) {
    console.log("Customer Compliance Frameworks Error:", error);
    throw error;
  }
};

export const fetchCustomerComplianceFrameworkControls = async (frameworkId) => {
  try {
    const response = await apiConfig.get(
      `/api/ai_dspm/customer-compliance/frameworks/${frameworkId}/controls/`
    );
    return response.data;
  } catch (error) {
    console.log("Customer Compliance Controls Error:", error);
    throw error;
  }
};

export const uploadCustomerComplianceControlDocument = async (controlId, file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    const response = await apiConfig.post(
      `/api/ai_dspm/customer-compliance/controls/${controlId}/upload-document/`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return response.data;
  } catch (error) {
    console.log("Customer Compliance Document Upload Error:", error);
    throw error;
  }
};

// ================= Reports =================

export const fetchReports = async () => {
  try {
    const response = await apiConfig.get("/api/ai_dspm/reports/");

    return response.data;
  } catch (error) {
    console.log("Reports Error:", error);
    throw error;
  }
};

export const downloadReport = async (id) => {
  try {
    const response = await apiConfig.get(
      `/api/ai_dspm/reports/${id}/download/`,
      {
        responseType: "blob",
      },
    );

    return response.data;
  } catch (error) {
    console.log("Download Report Error:", error);
    throw error;
  }
};

export const fetchReportById = async (id) => {
  try {
    const response = await apiConfig.get(`/api/ai_dspm/reports/${id}/`);

    return response.data;
  } catch (error) {
    console.log("Report Detail Error:", error);
    throw error;
  }
};

// ================= Settings =================

export const fetchSettings = async () => {
  try {
    const response = await apiConfig.get("/api/ai_dspm/settings/");

    return response.data;
  } catch (error) {
    console.log("Settings Error:", error);
    throw error;
  }
};

export const updateSettings = async (data) => {
  try {
    const response = await apiConfig.put("/api/ai_dspm/settings/", data);

    return response.data;
  } catch (error) {
    console.log("Update Settings Error:", error);
    throw error;
  }
};
